"use strict";
// export enum wxappHost {
// 	ALPHA = '',
// 	PROD = ''
// }
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkhrefUrl = exports.serializeParams = exports.routerType = exports.paymentPath = exports.openTagList = exports.jsApiList = void 0;
// web-view网页中支持的JSSDK接口,相关接口2，签名配置使用
exports.jsApiList = [
    'checkJSApi',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
    'getLocalImgData',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'onVoicePlayEnd',
    'uploadVoice',
    'downloadVoice',
    'translateVoice',
    'getNetworkType',
    'openLocation',
    'getLocation',
    'startSearchBeacons',
    'stopSearchBeacons',
    'onSearchBeacons',
    'scanQRCode',
    'chooseCard',
    'addCard',
    'openCard',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareQZone',
    // 以下公众号可用
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareWeibo',
    'openBusinessView',
    'hideMenuItems',
    'showMenuItems',
    'hideAllNonBaseMenuItem',
    'showAllNonBaseMenuItem',
    'setNavigationBarTitle'
];
// 需要使用的开放标签列表
exports.openTagList = [
    'wx-open-launch-weapp',
    'wx-open-launch-app'
];
var paymentPath;
(function (paymentPath) {
    paymentPath["WXPATH"] = "/pages/common/pay/pay?";
    paymentPath["PAYSUCCESS"] = "payresult=success";
    paymentPath["PAYFAIL"] = "payresult=fail";
    paymentPath["WXPUSHHOMEPATH"] = "/pages/tabBar/index/index";
})(paymentPath = exports.paymentPath || (exports.paymentPath = {}));
var routerType;
(function (routerType) {
    // 跳转到 tabBar 页面，并关闭其他所有非 tabBar 页面
    routerType["SWITCHTAB"] = "switchTab";
    // 关闭所有页面，打开到应用内的某个页面
    routerType["RELAUNCH"] = "reLaunch";
    // 关闭当前页面，跳转到应用内的某个页面。但是不允许跳转到 tabbar 页面
    routerType["REDIRECTTO"] = "redirectTo";
    // 保留当前页面，跳转到应用内的某个页面。但是不能跳到 tabbar 页面。使用 wx.navigateBack 可以返回到原页面。小程序中页面栈最多十层
    routerType["NAVIGATETO"] = "navigateTo";
    // 关闭当前页面，返回上一页面或多级页面。可通过 getCurrentPages 获取当前的页面栈，决定需要返回几层
    routerType["NAVIGATEBACK"] = "navigateBack";
})(routerType = exports.routerType || (exports.routerType = {}));
exports.serializeParams = function (obj) {
    var strArr = [];
    for (var key in obj) {
        var value = obj[key];
        if (key.search(/(Url)|(package)|(paySign)/) !== -1)
            value = encodeURIComponent(decodeURIComponent(value));
        strArr.push(key + "=" + value);
    }
    return strArr.join('&');
};
exports.checkhrefUrl = function (hrefUrl, paras) {
    var href = hrefUrl;
    var re = new RegExp('(' + paras + '&?)|(&?' + paras + ')', 'g');
    return href.replace(re, '');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/wxapp-sdk/dist/config.js
// module id = MWiq
// module chunks = 1